import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { IconList } from 'ui';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';

import type { JSX } from "react";

interface FactItemBowtieProps extends ComponentProps, FactItemProps {
   bowtieSupported: boolean;
   defaultIcon?: JSX.Element;
}

export const BowtieFactItem = (props: FactItemBowtieProps) => {
  const { title, defaultIcon, bowtieSupported, tooltip, portalTarget } = props;
  const iconBowtieAbsolutePath = toAbsoluteUrl('i/bowtie.svg');
  const icons = [{ description: tooltip, icon: iconBowtieAbsolutePath, value: 0, propName: 'bowtie' }];
  if (!bowtieSupported) { return null }
  return <FactLink id={props.componentId} classNames={`fact-item icon-line`} url={`/bowtie/${props.caseId}`}>
    <IconList title={title} valueItems={icons} defaultIcon={defaultIcon} portalTarget={portalTarget} />
  </FactLink>;
};
